import { createContext, useContext, useEffect, useState } from "react";
import Globals from "../services/Globals";
import { TReviews, TSize } from "../constants/types";
import { setLanguage } from "@fluentui/react";

interface GlobalContextProps {
    DevEnabled: boolean;
    DebugEnabled: boolean;
    BitcoinEnabled: boolean;
    ReviewID: string;
    DLog: Function;
    ImagesUrlVersionAddition: string;

    GlobalInit: Function;

    CacheCollectedAt: Date;
    SITE_MESSAGE_START_DATE: Date;
    SITE_MESSAGE_END_DATE: Date;
    Refresh: Function;
    Strings: any;
    SetLanguage: Function;
    InitDone: boolean;
    SITE_MESSAGE: string;
    HIDDEN_SETS: string;
    selectedBaseSetKey: number;
    selectedSetKey: number;
    selectedSetName: string;
    SetselectedSetName: Function;
    CAROUSEL_PROMO_SET_ID: string;
    PROMO1_IMAGE_URL: string;
    PROMO2_IMAGE_URL: string;
    CONFIG_PROMO2_IMAGE_URL: string;

    Callbacks: Function[];

    MainCarouselSets: number[];
    SetMainCarouselSets: Function;

    PageWidth: number;
    SetPageWidth: Function;

    IsMobile: boolean;
    SetIsMobile: Function;

    ShowMessage: Function;
    SetShowMessage: Function;

    ToastMessage: string;
    SetToastMessage: Function;

    AddCallback: Function;
    ClearCallBack: Function;

    AnimationsEnabled: boolean;
    SetAnimationsEnabled: Function;
    ShowFooter: boolean;
    SetShowFooter: Function;
    Reviews: TReviews;
    showAvailableOnly: boolean;
    setshowAvailableOnly: Function;
    windowSize: TSize;
    SetwindowSize: Function;
    GlobalImagesVersion: string;
    DEFAULT_SEND_COST: number;
    UNDERCONSTRUCTION: boolean;
    DEV_API_URL: string;
    PRODUCT_TAGS: string;
    SITE_KEYWORDS: string;
    SITE_DESCRIPTION: string;
    OUT_EMAIL: string;
    WHATSAPP: string;
    SITE_TITLE: string;
    SITE_ADRESS: string;
    ALTERNATIVE_SALES_URL: string;
    ALTERNATIVE_SALES_NAME: string;
    NO_REVIEWS_URLS: any;
    SHOW_PROMOTED_MIN_WIDTH: number;
    FOOTER_TEXT: string;
    SHOW_ALL_SET: boolean;
    BANNER_COLOR: string;
    SET_COLOR: string;
    SET_MENU_COLOR: string;
    BGCOLOR: string;
    FOOTERHEADERBGCOLOR: string;
    FOOTERHEADERFONTCOLOR: string;
    SHOWSETCOUNTTAG: boolean;
    SETCOUNTTAGLOCATION: string;
    BUYCOMPLETECOLLECTION: boolean;
    BUYCOMPLETECOLLECTIONDISCOUNT: number;
    BUYCOMPLETESET: boolean;
    BUYCOMPLETESETDISCOUNT: number;
}

const langFile = `${process.env.PUBLIC_URL}/lang.json`;
const GlobalContext = createContext<GlobalContextProps>({} as GlobalContextProps);

export const useGlobalContextContext = () => {
    const context = useContext(GlobalContext);
    if (context === undefined) {
        throw new Error("Custom context GlobalContext must be used within a CustomContextProvider");
    }
    return context;
};

export class OrientationValues {
    portraid: number;
    landscape: number;
}

export const GlobalContextProvider: React.FC = ({ children }) => {
    const [langJson, SetlangJson] = useState<any>();
    const [Callbacks, SetCallbacks] = useState<Function[]>([]);
    const [MainCarouselSets, SetMainCarouselSets] = useState<number[]>([]);
    const [PageWidth, SetPageWidth] = useState<number>(window.innerWidth - 25 > 1232 ? 1232 : window.innerWidth);
    const [IsMobile, SetIsMobile] = useState<boolean>(false);
    const [ShowMessage, SetShowMessage] = useState<Function>();
    const [ToastMessage, SetToastMessage] = useState<string>();
    const [AnimationsEnabled, SetAnimationsEnabled] = useState<boolean>(true);
    const [ShowFooter, SetShowFooter] = useState<boolean>(false);

    const [CacheCollectedAt, SetCacheCollectedAt] = useState<Date>();
    const [SITE_MESSAGE_START_DATE, SetSITE_MESSAGE_START_DATE] = useState<Date>();
    const [SITE_MESSAGE_END_DATE, SetSITE_MESSAGE_END_DATE] = useState<Date>();
    const [Refresh, SetRefresh] = useState<Function>();
    const [Strings, SetStrings] = useState<any>();
    const [InitDone, SetInitDone] = useState<boolean>();
    const [SITE_MESSAGE, SetSITE_MESSAGE] = useState<string>();
    const [HIDDEN_SETS, SetHIDDEN_SETS] = useState<string>();
    const [selectedBaseSetKey, SetselectedBaseSetKey] = useState<number>();
    const [selectedSetKey, SetselectedSetKey] = useState<number>();
    const [selectedSetName, SetselectedSetName] = useState<string>();
    const [CAROUSEL_PROMO_SET_ID, SetCAROUSEL_PROMO_SET_ID] = useState<string>();
    const [PROMO1_IMAGE_URL, SetPROMO1_IMAGE_URL] = useState<string>();
    const [PROMO2_IMAGE_URL, SetPROMO2_IMAGE_URL] = useState<string>();
    const [CONFIG_PROMO2_IMAGE_URL, SetCONFIG_PROMO2_IMAGE_URL] = useState<string>();
    const [DEFAULT_SEND_COST, SetDEFAULT_SEND_COST] = useState<number>();
    const [UNDERCONSTRUCTION, SetUNDERCONSTRUCTION] = useState<boolean>();
    const [Reviews, SetReviews] = useState<TReviews>();
    const [GlobalImagesVersion, SetGlobalImagesVersion] = useState<string>("1");
    const [showAvailableOnly, setshowAvailableOnly] = useState<boolean>(true);
    const [windowSize, SetwindowSize] = useState<TSize>({ x: window.innerWidth > 1232 ? 1232 : window.innerWidth, y: window.innerHeight });
    const [DEV_API_URL, setDEV_API_URL] = useState<string>();
    const [PRODUCT_TAGS, setPRODUCT_TAGS] = useState<string>();
    const [SITE_KEYWORDS, setSITE_KEYWORDS] = useState<string>();
    const [SITE_DESCRIPTION, setSITE_DESCRIPTION] = useState<string>();
    const [OUT_EMAIL, setOUT_EMAIL] = useState<string>();
    const [WHATSAPP, setWHATSAPP] = useState<string>();
    const [SITE_TITLE, setSITE_TITLE] = useState<string>();
    const [SITE_ADRESS, setSITE_ADRESS] = useState<string>();
    const [ALTERNATIVE_SALES_URL, setALTERNATIVE_SALES_URL] = useState<string>();
    const [ALTERNATIVE_SALES_NAME, setALTERNATIVE_SALES_NAME] = useState<string>();
    const [NO_REVIEWS_URLS, setNO_REVIEWS_URLS] = useState<[{ Image: string; URL: string; }]>();
    const [SHOW_PROMOTED_MIN_WIDTH, set_SHOW_PROMOTED_MIN_WIDTH] = useState<number>(960);
    const [FOOTER_TEXT, set_FOOTER_TEXT] = useState<string>("");
    const [SHOW_ALL_SET, set_SHOW_ALL_SET] = useState<boolean>(true);
    const [BANNER_COLOR, set_BANNER_COLOR] = useState<string>();
    const [SET_COLOR, set_SET_COLOR] = useState<string>();
    const [SET_MENU_COLOR, set_SET_MENU_COLOR] = useState<string>();
    const [BGCOLOR, set_BGCOLOR] = useState<string>();
    const [FOOTERHEADERBGCOLOR, set_FOOTERHEADERBGCOLOR] = useState<string>("chocolate");
    const [FOOTERHEADERFONTCOLOR, set_FOOTERHEADERFONTCOLOR] = useState<string>();
    const [SHOWSETCOUNTTAG, setSHOWSETCOUNTTAG] = useState<boolean>();
    const [SETCOUNTTAGLOCATION, setSETCOUNTTAGLOCATION] = useState<string>();
    const [BUYCOMPLETECOLLECTION, setBUYCOMPLETECOLLECTION] = useState<boolean>();
    const [BUYCOMPLETECOLLECTIONDISCOUNT, setBUYCOMPLETECOLLECTIONDISCOUNT] = useState<number>();
    const [BUYCOMPLETESET, setBUYCOMPLETESET] = useState<boolean>();
    const [BUYCOMPLETESETDISCOUNT, setBUYCOMPLETESETDISCOUNT] = useState<number>();


    let DevEnabled = Globals.GetParam('dev') ? true : false;
    let DebugEnabled = Globals.GetParam('debug') ? true : false;
    const BitcoinEnabled = Globals.GetParam('BTC') ? true : false;
    const ReviewID = Globals.GetParam('reviewid');
    const ImagesUrlVersionAddition = Date.now().toString();

    if (document.location.origin === "http://localhost:3000") {
        DevEnabled = true;
        DebugEnabled = true;
    }

    useEffect(() => {
        window.addEventListener('resize', SetWindowInnerWidthBeforeOrientationChange);

        (async function fetchConfig() {
            try {
                const resp = await (await fetch(langFile)).json();
                SetlangJson(resp);
                SetStrings(resp.Nederlands);
            } catch (e) {
                console.log(e);
            }
        }());
    }, []);

    const SetLanguage = (language: string) => {
        if (langJson) {
            SetStrings(langJson[language]);
        }
    }

    const AddCallback = (f: Function) => {
        let buff = Callbacks;
        buff.push(f);
        SetCallbacks(buff);
    }

    const ClearCallBack = () => {
        SetCallbacks([]);
    }

    const GlobalInit = (data, language: string, _showMessage: Function, _IsMobile: boolean, _PageWidth: number, refresh: Function) => {
        SetLanguage(language);
        SetShowMessage(_showMessage);
        SetIsMobile(_IsMobile);
        SetPageWidth(_PageWidth);
        SetReviews(data.reviews);

        SetRefresh(refresh);
        SetCacheCollectedAt(new Date(data.CollectedAt));
        data.config.forEach(d => {
            switch (d.name) {
                case "BUYCOMPLETECOLLECTION":
                    setBUYCOMPLETECOLLECTION(d.value === "1" ? true : false);
                    break;
                case "BUYCOMPLETECOLLECTIONDISCOUNT":
                    setBUYCOMPLETECOLLECTIONDISCOUNT(+d.value);
                    break;
                case "BUYCOMPLETESET":
                    setBUYCOMPLETESET(d.value === "1" ? true : false);
                    break;
                case "BUYCOMPLETESETDISCOUNT":
                    setBUYCOMPLETESETDISCOUNT(+d.value);
                    break;
                case "SHOWSETCOUNTTAG":
                    setSHOWSETCOUNTTAG(d.value === "1" ? true : false);
                    break;
                case "SETCOUNTTAGLOCATION":
                    setSETCOUNTTAGLOCATION(d.value);
                    break;
                case "FOOTERHEADERFONTCOLOR":
                    set_FOOTERHEADERFONTCOLOR(d.value);
                    break;
                case "FOOTERHEADERBGCOLOR":
                    set_FOOTERHEADERBGCOLOR(d.value);
                    break;
                case "BGCOLOR":
                    set_BGCOLOR(d.value);
                    break;
                case "SET_MENU_COLOR":
                    set_SET_MENU_COLOR(d.value);
                    break;
                case "BANNER_COLOR":
                    set_BANNER_COLOR(d.value);
                    break;
                case "SET_COLOR":
                    set_SET_COLOR(d.value);
                    break;
                case "SHOW_ALL_SET":
                    set_SHOW_ALL_SET(d.value === 0 ? false : true);
                    break;
                case "FOOTER_TEXT":
                    set_FOOTER_TEXT(d.value);
                    break;
                case "SHOW_PROMOTED_MIN_WIDTH":
                    set_SHOW_PROMOTED_MIN_WIDTH(Number(d.value));
                    break;
                case "DEV_API_URL":
                    setDEV_API_URL(d.value);
                    break;
                case "PRODUCT_TAGS":
                    setPRODUCT_TAGS(d.value);
                    break;
                case "SITE_KEYWORDS":
                    setSITE_KEYWORDS(d.value);
                    break;
                case "SITE_DESCRIPTION":
                    setSITE_DESCRIPTION(d.value);
                    break;
                case "OUT_EMAIL":
                    setOUT_EMAIL(d.value);
                    break;
                case "WHATSAPP":
                    setWHATSAPP(d.value);
                    break;
                case "SITE_TITLE":
                    setSITE_TITLE(d.value);
                    break;
                case "SITE_ADRESS":
                    setSITE_ADRESS(d.value);
                    break;
                case "ALTERNATIVE_SALES_URL":
                    setALTERNATIVE_SALES_URL(d.value);
                    break;
                case "ALTERNATIVE_SALES_NAME":
                    setALTERNATIVE_SALES_NAME(d.value);
                    break;
                case "NO_REVIEWS_URLS":
                    setNO_REVIEWS_URLS(JSON.parse(d.value));
                    break;
                case "UNDERCONSTRUCTION":
                    SetUNDERCONSTRUCTION(d.value == "1" ? true : false);
                    break;
                case "SEND_COST":
                    SetDEFAULT_SEND_COST(Number(d.value));
                    break;
                case "HIDDEN_SETS":
                    SetHIDDEN_SETS(d.value);
                    break;
                case "selectedBaseSetKey":
                    SetselectedBaseSetKey(Number(d.value));
                    break;
                case "selectedSetKey":
                    SetselectedSetKey(Number(d.value));
                    break;
                case "CAROUSEL_PROMO_SET_ID":
                    SetCAROUSEL_PROMO_SET_ID(d.value);
                    break;
                case "PROMO1_IMAGE_URL":
                    SetPROMO1_IMAGE_URL(d.value);
                    break;
                case "PROMO2_IMAGE_URL":
                    SetPROMO2_IMAGE_URL(d.value);
                    break;
                case "CONFIG_PROMO2_IMAGE_URL":
                    SetCONFIG_PROMO2_IMAGE_URL(d.value);
                    break;
                case "SITE_MESSAGE":
                    SetSITE_MESSAGE(d.value);
                    break;
                case "SITE_MESSAGE_START_DATE":
                    const dateparts = d.value.split('-');
                    SetSITE_MESSAGE_START_DATE(new Date(dateparts[2], Number(dateparts[0])-1, dateparts[1])); //All this bullshit because IOS refuses to parse dates like everyone else
                    break;
                case "SITE_MESSAGE_END_DATE":
                    const dateparts2 = d.value.split('-');
                    SetSITE_MESSAGE_END_DATE(new Date(dateparts2[2], Number(dateparts2[0])-1, dateparts2[1])); //All this bullshit because IOS refuses to parse dates like everyone else
                    break;
                case "DefaultSoldOutEnabled":
                    if (d.value === "1") {
                        setshowAvailableOnly(false);
                    } else {
                        setshowAvailableOnly(true);
                    }
                    break;
                case "GlobalImagesVersion":
                    SetGlobalImagesVersion(d.value);
                    break;
                case "MainCarouselSets":
                    const parts = d.value.split(',');
                    let mcs: number[] = [];
                    parts.forEach(p => {
                        mcs.push(Number(p));
                    });
                    SetMainCarouselSets(mcs);
                    break;
                default:
                    break;
            }
        });
        SetInitDone(true);
        Callbacks.forEach(f => {
            f();
        });
    }

    const DLog = (message) => {
        if (DebugEnabled) {
            switch (typeof message) {
                case "string":
                    console.log("DEBUG: " + message);
                    break;
                default:
                    console.log("[START DEBUG OBJ]");
                    console.log(message);
                    console.log("[END DEBUG OBJ]");
                    break;
            }
        }
    }

    const SetWindowInnerWidthBeforeOrientationChange = () => {
        DLog("GlobalContext SetWindowInnerWidthBeforeOrientationChange()");
        let w = window.innerWidth > screen.width ? screen.width : window.innerWidth;

        SetIsMobile(w < 960 ? true : false);
        SetwindowSize({ x: w > 1232 ? 1232 : w, y: window.innerHeight });
        SetPageWidth(w - 25 > 1232 ? 1232 : w);
    }

    return (
        <GlobalContext.Provider value={{
            DevEnabled,
            DebugEnabled,
            BitcoinEnabled,
            ReviewID,
            DLog,
            ImagesUrlVersionAddition,
            GlobalInit,
            CacheCollectedAt,
            SITE_MESSAGE_START_DATE,
            SITE_MESSAGE_END_DATE,
            Refresh,
            Strings,
            SetLanguage,
            InitDone,
            SITE_MESSAGE,
            HIDDEN_SETS,
            selectedBaseSetKey,
            selectedSetKey,
            selectedSetName,
            SetselectedSetName,
            CAROUSEL_PROMO_SET_ID,
            PROMO1_IMAGE_URL,
            PROMO2_IMAGE_URL,
            CONFIG_PROMO2_IMAGE_URL,
            Callbacks,
            MainCarouselSets,
            SetMainCarouselSets,
            PageWidth,
            SetPageWidth,
            IsMobile,
            SetIsMobile,
            ShowMessage,
            SetShowMessage,
            ToastMessage,
            SetToastMessage,
            AddCallback,
            ClearCallBack,
            AnimationsEnabled,
            SetAnimationsEnabled,
            ShowFooter,
            SetShowFooter,
            Reviews,
            showAvailableOnly,
            setshowAvailableOnly,
            windowSize,
            SetwindowSize,
            GlobalImagesVersion,
            DEFAULT_SEND_COST,
            UNDERCONSTRUCTION,
            DEV_API_URL,
            PRODUCT_TAGS,
            SITE_KEYWORDS,
            SITE_DESCRIPTION,
            OUT_EMAIL,
            WHATSAPP,
            SITE_TITLE,
            SITE_ADRESS,
            ALTERNATIVE_SALES_URL,
            ALTERNATIVE_SALES_NAME,
            NO_REVIEWS_URLS,
            SHOW_PROMOTED_MIN_WIDTH,
            FOOTER_TEXT,
            SHOW_ALL_SET,
            BANNER_COLOR,
            SET_COLOR,
            SET_MENU_COLOR,
            BGCOLOR,
            FOOTERHEADERBGCOLOR,
            FOOTERHEADERFONTCOLOR,
            SHOWSETCOUNTTAG,
            SETCOUNTTAGLOCATION,
            BUYCOMPLETECOLLECTION,
            BUYCOMPLETECOLLECTIONDISCOUNT,
            BUYCOMPLETESET,
            BUYCOMPLETESETDISCOUNT
        }}>
            {children}
        </GlobalContext.Provider>
    );
};

export default GlobalContext;